// ** Reactstrap Imports
import { Row, Col } from "reactstrap";

// ** Third party components
import { Trans, useTranslation } from "react-i18next";

import HowItWorksCard from "./HowItWorksCard";

const HowItWorks = ({ data, loading }) => {
  const { t } = useTranslation();
  return (
    <>
      <Row className="mb-3">
        <Col>
          <h3 className="fw-bold">
            <Trans
              i18nKey="how_it_work_title"
              values={{ name: t("site_name") }}
              components={{ span: <span className="text-primary" /> }}
            />
          </h3>
        </Col>
      </Row>
      <Row className="justify-content-between">
        {data?.map((item, idx) => (
          <Col className={`text-center`} sm="12" lg="3" key={idx}>
            <HowItWorksCard loading={loading} item={item} />
          </Col>
        ))}
      </Row>
    </>
  );
};

export default HowItWorks;
